import { useState, useEffect } from 'react'
import COMPANY_1 from 'assets/images/company/1.png'
import COMPANY_2 from 'assets/images/company/2.png'
import MOBILE_COMPANY_2 from 'assets/images/company/mobile_2.png'
import GENSTATION_LOGO from 'assets/images/logo/logo_horizon.png'
import { COMPANY_DESC_INFO } from 'assets/json/companyInfo.js'
import CompanyDescSwiper from '../../components/swiper/CompanyDescSwiper'
import { COMPANY_NAME_KO, COMPANY_NAME_EN } from '../../utils/Utils'
import './CompanyMain.scss'

/**
 * @file 회사소개 main 화면
 */
function CompanyMain() {
    const [width, setWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return (
        <>
            <div className="company-one" style={{ backgroundImage: `url(` + COMPANY_1 + `)` }}>
                <div className="text-box">
                    <div className="sub">배터리 교체로 만드는 지속가능한 에너지</div>
                    <div className="t1">
                        탄소 <strong>ZERO</strong>를 위한 노력
                    </div>
                    {/* .des 혁신적인 디자인과 기술력은 <br/>\n경험하지 못한 새로운 라이딩 경험을 제공합니다. */}
                </div>
            </div>
            <div className="company-two">
                <div className="text-box">
                    <div className="sub">에너지 사용의 혁신으로 더 나은 세상을 만듭니다.</div>
                    <div className="t1">
                        새로운 전기 모빌리티 플랫폼
                        <br />
                        {COMPANY_NAME_KO}
                    </div>
                    <div className="des">
                        {COMPANY_NAME_KO}(주)는 고고로와 독점 계약을 맺고
                        <br /> 2022년에 출범한 전기 모빌리티 플랫폼 회사입니다.
                        <br /> 전국에 인프라를 구축하여 국내 BSS의 기준이 되고자 합니다
                    </div>
                    <div className="des_img">
                        <img
                            className="genstation_gogoro"
                            src={width <= 768 ? MOBILE_COMPANY_2 : COMPANY_2}
                            alt={`${COMPANY_NAME_EN} gogoro network contract conclusion`}
                        />
                    </div>
                </div>
            </div>
            <div className={'describe-wrapper-one company-describe-wrapper'}>
                <div className="describe-title">
                    <div className="t1">자유롭고 편리한 운행을 위한</div>
                </div>
                <div className="list-pc">
                    <div className="list-inner">
                        {COMPANY_DESC_INFO.map((val, i) => (
                            <div
                                className="img-box"
                                style={{ backgroundImage: `url(${val.imgUrl})` }}
                                key={'company-desc-info-img-' + i}></div>
                        ))}
                    </div>
                </div>
                <CompanyDescSwiper />
            </div>
            <div className="company-three">
                <div className="text-box">
                    <div className="sub">닷스테이션이 꿈꾸는</div>
                    <div className="t1">INFRA With Together</div>
                    <div className="des_text">
                        기술과 환경, 사람이 함께 상생하는 인프라를 위해
                        <br />
                        지속가능한 친환경 에너지 플랫폼을 만들고자 노력합니다.
                    </div>
                    <div className="des_logo">
                        <img className="genstation_gogoro" src={GENSTATION_LOGO} alt={`${COMPANY_NAME_EN} logo`} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompanyMain
